import React from 'react';
import { ReactComponent as FolderIcon } from '../../shared/icons/folder-icon.svg';
import styles from './styles.module.scss';

export interface FolderData {
  id: string;
  title: string;
  updatedAt: string;
  isFolder: boolean;
  onClick?: () => void;
}

interface MobileFolderItemProps {
  folder: FolderData;
  onClick?: () => void;
}

export const MobileFolderItem: React.FC<MobileFolderItemProps> = ({ folder, onClick }) => {
  return (
    <div className={styles.folderItem} onClick={onClick}>
      <div className={styles.folderItem__header}>
        <div className={styles.folderItem__title}>
          <FolderIcon width={20} height={20} className={styles.folderItem__icon} />
          {folder.title}
        </div>
      </div>
    </div>
  );
};
